export default __webpack_public_path__ + "static/media/avatar_bg_orochimaru.6d81559c.png";